import * as TYPES from '../types'
import api from '../../api'

const state = {
  list: {
    pageIndex: 1,
    pageSize: 20,
    totalCount: 0,
    totalPage: 0,
    items: []
  }
}

const mutations = {
  [TYPES.ON_GET_NOTIFICATIONS](state, data) {
    state.list.items = data
  }
}

const actions = {
  [TYPES.DO_GET_NOTIFICATIONS]({
    commit
  }, pageIndex) {
    return new Promise((resolve, reject) => {
      api
        .DO_GET_NOTIFICATIONS(pageIndex)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_NOTIFICATIONS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_READ_NOTIFICATION]({
    commit
  }, notificationId) {
    return new Promise((resolve, reject) => {
      api.DO_READ_NOTIFICATION(notificationId)
        .then(res => {
          if (res.data.ok) {
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/notify.js